@if (protocolVersions.data()?.length === 0 && !protocolVersions.isLoading()) {
  <aux-no-protocol-versions-link class="my-4 block" />
}

<form [formGroup]="siteBudgetForm">
  <div class="flex items-center justify-between">
    <div class="grid grid-cols-3 gap-4">
      <aux-protocol-version-dropdown formControlName="protocolVersion" class="w-[240px]" />

      <aux-site-budget-dropdown
        class="w-[240px]"
        formControlName="siteBudgetVersion"
        [selectedSiteId]="selectedSiteId()"
        [selectedProtocolVersion]="selectedProtocolVersion()"
      />

      <aux-effective-date-dropdown
        class="w-[240px]"
        #effectiveDateDropdown
        [editMode]="editMode()"
        [loading]="siteBudget.isLoading() || protocolVersions.isLoading()"
        [selectedProtocolVersion]="selectedProtocolVersion()"
        [selectedSiteBudgetVersion]="selectedBudgetVersion()"
        [site]="selectedSite()"
        formControlName="effectiveDate"
        [class.pt-[12px]]="!editMode()"
      />
    </div>

    <aux-site-amendment-button
      [selectedProtocolVersion]="selectedProtocolVersion()"
      [selectedSiteId]="selectedSiteId()"
      [disabled]="editMode()"
      (amendmentCreated)="onAmendmentCreated($event)"
    />
  </div>

  <aux-site-budget-grid
    #siteBudgetGrid
    class="mt-4 block"
    [editMode]="editMode()"
    [selectedBudgetVersion]="selectedBudgetVersion()"
    [selectedPatientGroup]="selectedPatientGroup()"
    [selectedProtocolVersion]="selectedProtocolVersion()"
    [selectedSiteId]="selectedSiteId()"
    [selectedCostType]="siteBudgetForm.controls.costType.value!"
    (goToEditMode)="goToEditMode()"
    [isDataProcessing]="isDataProcessing()"
    [site]="selectedSite()"
    [disabled]="!protocolVersions.data()?.length"
  >
    <div class="flex items-center justify-between px-3 pb-2 pt-3">
      <div class="flex items-center space-x-3">
        <aux-site-budget-cost-type-dropdown formControlName="costType" class="w-[240px]" />

        <aux-patient-group-dropdown
          class="w-[240px]"
          formControlName="patientGroup"
          [isVisitCostSelected]="isVisitCostSelected()"
        />
      </div>

      <aux-site-budget-table-buttons
        [editMode]="editMode()"
        (edit)="goToEditMode()"
        (cancelChanges)="cancelChanges()"
        (saveChanges)="saveChanges()"
        [siteBudgetGridComponent]="siteBudgetGrid"
        [isSiteInvoiceables]="isSiteInvoiceablesSelected()"
        [isDataProcessing]="isDataProcessing()"
        [disabled]="!protocolVersions.data()?.length"
        (removeRows)="onRemoveRows()"
      />
    </div>
  </aux-site-budget-grid>

  <div class="mt-4 grid grid-cols-2 gap-4">
    <div class="flex h-full flex-col">
      <p class="mb-1 text-base font-bold">Reason for Amendment</p>
      <aux-site-budget-note
        formControlName="note"
        [selectedSiteBudgetVersionId]="selectedBudgetVersion()"
        [noteId]="siteBudgetForm.controls.noteId.value || null"
        [selectedSiteId]="selectedSiteId()"
        class="flex-grow"
      />
    </div>

    <aux-site-budget-supporting-documents
      [isInitialSiteBudget]="isInitialSiteBudget()"
      [selectedSiteId]="selectedSiteId()"
      [selectedSiteBudgetVersion]="selectedBudgetVersion()"
      class="flex-grow"
    />
  </div>
</form>
